import React from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { IStore } from 'Store/.';
import { bindActionCreators, Dispatch } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getIsMobile } from 'Store/Screen/selectors';
import { fetchEvent } from 'Pages/EventDetailPage/Redux/thunks';
import EventDetailPage from 'Pages/EventDetailPage/EventDetailPage';

import { 
  getIsFetching, 
  getIsFetchFailed, 
  getMinPrice,
  getFirstDate,
  getLastDate,
  getEventWithSortedPerformances,
} from 'Pages/EventDetailPage/Redux/selectors';

interface IPropsInternal {
  isFetching: boolean;
  isFetchFailed: boolean;
  isMobile: boolean;
  event: Julius.Website.EventDetailViewModel;
  firstDate: Date;
  lastDate: Date;
  minPrice: number;
  fetchEvent: (id: number, code: string) => void;
}

interface IState {
  isShowingVenueModal: boolean;
}

type Props = IPropsInternal & RouteComponentProps<{ eventID: number }>;

export class EventDetailPageContainer extends React.PureComponent<Props, IState> {
  private performanceListRef: HTMLElement;

  constructor(props: Props) {
    super(props);

    this.state = {
      isShowingVenueModal: false,
    }
  }

  componentDidMount() {
    const { eventID } = this.props.match.params;
    const queryParams = queryString.parse(this.props.location.search);
    this.props.fetchEvent(eventID, queryParams.kampanjkod);
  }

  onPerformanceClick = (performanceID: number) => {
    this.props.history.push(`/order/${ performanceID }`);
  }

  onShowVenueInfo = () => {
    this.setState({ isShowingVenueModal: true });
  }
  
  onHideVenueInfo = () => {
    this.setState({ isShowingVenueModal: false });
  }

  onBuyTickets = () => {
    this.performanceListRef.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  onBuyVoucher = () => {
    const { history } = this.props;
    history.push('/order/presentkort');
  }

  setPerformanceListRef= (node: HTMLElement) => {
    this.performanceListRef = node;
  }

  render() {
    return (
      <EventDetailPage 
        event={ this.props.event }
        minPrice={ this.props.minPrice }
        firstDate={ this.props.firstDate }
        lastDate={ this.props.lastDate }
        isMobile={ this.props.isMobile }
        isFetching={ this.props.isFetching }
        isFetchFailed={ this.props.isFetchFailed }
        isShowingVenueModal={ this.state.isShowingVenueModal }
        onShowVenueInfo={ this.onShowVenueInfo }
        onHideVenueInfo={ this.onHideVenueInfo }
        onBuyTickets={ this.onBuyTickets }
        onBuyVoucher={ this.onBuyVoucher }
        onPerformanceClick={ this.onPerformanceClick }
        setPerformanceListRef={ this.setPerformanceListRef }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetching(state),
    isFetchFailed: getIsFetchFailed(state),
    isMobile: getIsMobile(state),
    event: getEventWithSortedPerformances(state),
    firstDate: getFirstDate(state),
    lastDate: getLastDate(state),
    minPrice: getMinPrice(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchEvent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(EventDetailPageContainer);


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/EventDetailPageContainer.tsx